import React from "react";
import { useSelector } from "react-redux";

import { Icon, IconName, Heading } from "@telia/teddy";
import "./ModalSellingPoints.less";
import { TextBlockUsp } from "../../../../../../models";
import { isUspVisibleInFlow } from "../../../../../../shared/uspFlow";
import { isRetailer } from "../../../../app/state/selectors";

interface ModalSellingPointsProps {
    sellingPoints: TextBlockUsp[];
}

const ModalSellingPoints: React.FC<ModalSellingPointsProps> = ({ sellingPoints }) => {
    const isNexus = useSelector(isRetailer);

    return (
        <div className="modal-selling-points">
            {(sellingPoints || [])
                .filter((point) => isUspVisibleInFlow(point.flow, isNexus))
                .map((point) => (
                    <div className="modal-selling-point" key={`modal-selling-point__${point.heading}`}>
                        <div className="modal-selling-point__icon-wrapper">
                            <Icon
                                className="modal-selling-point__icon"
                                name={point.icon as IconName}
                                aria-hidden="true"
                                focusable="false"
                            />
                        </div>
                        <div className="modal-selling-point__content">
                            <Heading mb="100" as="h3" variant="title-100" className="modal-selling-point__heading">
                                <div dangerouslySetInnerHTML={{ __html: point.heading || "" }} />
                            </Heading>
                            <span className="modal-selling-point__subtitle">{point.subtext}</span>
                            <div
                                className="modal-selling-point__description"
                                dangerouslySetInnerHTML={{ __html: point.content || "" }}
                            />
                        </div>
                    </div>
                ))}
        </div>
    );
};

export default ModalSellingPoints;
